import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>
          Блокнот на пружине на выбор: 48 или 96 листов
        </p>
        <p>
          Также, на выбор предлагается разлиновка страниц с обеих сторон: клетка стандартная (5мм) или в линейку. Или же отсутствие разлиновки вообще (белые листы)
        </p>
        <p>
          Обложка: матовая/глянцевая мелованная бумага 250 гр
        </p>
        <p>
          Переплет: пружина по короткой стороне
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
